import {get} from 'lodash'
import {IN_PROGRESS_PROJECT} from '@/constants/projectStatuses'
import {SIDE_HOURLY} from '@/constants/projectTypes'

export default {
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    setProjectBody (obj, subproject) {
      const {
        typeServiceProject = {},
        stepServiceProject = {},
        estCompletion,
        estStartDate
      } = obj

      const result = {
        name: obj.name,
        amount: subproject ? 1 : obj.currentAmount || obj.amount,
        dateStart: get(this.project, 'dateStart', new Date()),
        projectType: subproject ? SIDE_HOURLY.id : get(obj, 'projectType.id', obj.projectType),
        projectDescription: obj.projectDescription,
        status: get(obj, 'status', IN_PROGRESS_PROJECT.id),
        comments: get(obj, 'comments', []),
        kpiHelpUsers: [],
        managerComment: get(obj, 'managerComment', ''),
        includeOfKpi: get(obj, 'includeOfKpi', obj.includeOfKpi),
        client: get(obj, 'client.id', obj.client),
        percentComplete: obj.percentComplete,
        id: obj.id || obj._id,
        estCompletion,
        estStartDate
      }
      if (typeServiceProject !== null && typeServiceProject._id) result.typeServiceProject = typeServiceProject._id
      if (stepServiceProject !== null && stepServiceProject._id) result.stepServiceProject = stepServiceProject._id
      const dateLastUpdate = get(obj, 'dateLastUpdate', '')
      const kpiHelpUsers = get(obj, 'kpiHelpUsers', [])
      if (kpiHelpUsers) {
        result.kpiHelpUsers = kpiHelpUsers.map(item => {
          item.user = get(item, 'user.id', item.user)
          return item
        })
      }
      const businessConsultant = get(obj, 'businessConsultant._id', '')
      if (businessConsultant) result.businessConsultant = businessConsultant
      const projectManager = get(obj, 'projectManager._id', '')
      if (projectManager) {
        result.projectManager = projectManager
      } else {
        result.projectManager = null
      }
      if (dateLastUpdate) result.dateLastUpdate = dateLastUpdate
      const includeOfKpiComment = get(obj, 'includeOfKpiComment', '')
      if (includeOfKpiComment) result.includeOfKpiComment = includeOfKpiComment
      const dateNextUpdate = get(obj, 'dateNextUpdate', '')
      if (dateNextUpdate) result.dateNextUpdate = dateNextUpdate
      const supportManager = get(obj, 'supportManager', [])
      result.supportManager = supportManager.length ? supportManager.map((el) => el._id) : []
      const contactPm = get(obj, 'contactPm', [])
      result.contactPm = contactPm.length ? contactPm.map((el) => typeof el === 'string' ? el : el._id) : []
      const tags = get(obj, 'tags', [])
      result.tags = tags.map((el) => el.id || el._id || undefined)
      result.factValue = get(obj, 'factValue', result.amount)
      const invoiceId = get(this.project, 'invoiceId.id', '')
      if (invoiceId) {
        result.invoiceId = invoiceId
      }
      const userId = get(this.userInfo, 'id', '')
      if (userId) result.user = userId
      if (subproject) result.parentProjectId = subproject
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setProjectBody.js